import { useQuery } from "react-query";
import { getEmployeeDepartment } from "../../../../../actions/Utilities/EmployeeDepartment";

export const useEmployeeDepartment = () => {
  return useQuery("GetEmployeeDepartment", getEmployeeDepartment, {
    refetchOnWindowFocus: false,
  });
};
